export default __webpack_public_path__ + "d706b0a89dab2f3589cf7084652334ef.png";